import { constructUrl as modulesUrlConstructor } from 'web-store-modules/packages/url-constructor'

const variables = require('../../../variables/Variables.js');

export function constructUrl(urlObject) {
    return modulesUrlConstructor(urlObject, variables.s3Bucket)
}
